import { ProductReviewSort } from './types'

export const DEFAULT_REVIEWS_LIMIT = 3
export const DEFAULT_REVIEW_MEDIA_LIMIT = 10
export const MAX_REVIEW_PHOTOS = 10
export const MAX_REVIEW_VIDEOS = 1
export const MAX_REVIEW_ATTACHMENTS = MAX_REVIEW_PHOTOS + MAX_REVIEW_VIDEOS

export const RATING_LABELS: Record<number, string> = {
	1: 'Ожидал лучшего',
	2: 'Легкая неудовлетворенность',
	3: 'Без восторга',
	4: 'Все прекрасно',
	5: 'В полном восторге'
}

export type ReviewListMode = 'newest' | 'rating-high' | 'rating-low'
export type ReviewSortFilterMode = ReviewListMode | 'photo' | 'video'

export const REVIEW_SORT_OPTIONS: Array<{ value: ReviewListMode; label: string }> = [
	{ value: 'newest', label: 'Сначала новые' },
	{ value: 'rating-high', label: 'С высокой оценкой' },
	{ value: 'rating-low', label: 'С низкой оценкой' }
]

export const REVIEW_SORT_FILTER_OPTIONS: Array<{ value: ReviewSortFilterMode; label: string }> = [
	...REVIEW_SORT_OPTIONS,
	{ value: 'photo', label: 'С фото' },
	{ value: 'video', label: 'С видео' }
]

export const getReviewsApiSort = (mode: ReviewListMode): ProductReviewSort =>
	mode === 'rating-high' || mode === 'rating-low' ? 'rating' : 'newest'
